export default "__VITE_ASSET__Bt$GRvYn__"